// import React, { useEffect, useState } from 'react';
// import TradeCard from './../components/TradeCard';
// import config from '../config';
// import './../Trades.css';

// const Trades = () => {
//   const [trades, setTrades] = useState([]);

//   useEffect(() => {
//     const fetchTrades = async () => {
//       try {
//         const response = await fetch(`${config.API_BASE_URL}getOrders`);
//         const data = await response.json();
//         setTrades(data);
//       } catch (error) {
//         console.error('Error fetching trades:', error);
//       }
//     };

//     fetchTrades();
//   }, []);

//   return (
//     <div className="trades-page">
//       {trades.map((trade) => (
//         <TradeCard key={trade.orderId} trade={trade} />
//       ))}
//     </div>
//   );
// };

// export default Trades;





// import React, { useEffect, useState } from 'react';
// import TradeCard from './../components/TradeCard';
// import config from '../config';
// import './../Trades.css';

// const Trades = () => {
//   const [trades, setTrades] = useState([]);
//   const user_id = '689239'; // Replace with your actual user_id

//   useEffect(() => {
//     const fetchTrades = async () => {
//       try {
//         const response = await fetch(`${config.API_BASE_URL}getOrders`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({ user_id }),
//         });
//         const data = await response.json();
//         setTrades(data); // Assuming data is an array of trades
//       } catch (error) {
//         console.error('Error fetching trades:', error);
//       }
//     };

//     fetchTrades();
//   }, [user_id]);

//   return (
//     <div className="trades-page">
//       {trades.map((trade) => (
//         <TradeCard key={trade.orderId} trade={trade} />
//       ))}
//     </div>
//   );
// };

// export default Trades;




// import React, { useContext } from 'react';
// import TradeCard from './../components/TradeCard';
// import { WebSocketContext } from "../WebSocketContext";

// const Trades = () => {
//   const { trades, stocks, refreshTradesAndPortfolio } = useContext(WebSocketContext);

//   const handleRefresh = () => {
//     refreshTradesAndPortfolio("trades");
//   };

//   return (
//     <div className="trades-page">
//       <button onClick={handleRefresh}>Refresh Trades</button>
//       {/* Render trades using stocks from WebSocketContext */}
//       {trades.map(trade => (
//         <TradeCard 
//           key={trade.tradeId} 
//           stock={stocks[trade.symbol]} // Access real-time stock data from WebSocketContext
//           trade={trade} 
//         />
//       ))}
//     </div>
//   );
// }

// export default Trades;




import React, { useContext, useState, useEffect } from 'react';
import { WebSocketContext } from "../WebSocketContext";
import { useTheme } from '../contexts/ThemeContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { Search } from '@mui/icons-material';
import './../Trades.css';
import { Refresh } from '@mui/icons-material';
import { Close } from '@mui/icons-material';
import CachedIcon from '@mui/icons-material/Cached';
import config from '../config';

const Trades = () => {
  const { trades, stocks, refreshTradesAndPortfolio } = useContext(WebSocketContext);
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [filter, setFilter] = useState('executed');
  const [searchQuery, setSearchQuery] = useState('');
  const userId = Number(localStorage.getItem('userId'));

  // Handle navigation state from NetPositions
  useEffect(() => {
    if (location.state?.filterByScript) {
      setSearchQuery(location.state.filterByScript);
    }
  }, [location.state]);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleRefresh = () => {
    refreshTradesAndPortfolio("both");
  };

  const filteredTrades = trades.filter(trade => {
    if (filter === 'executed') return trade.orderStatus == "2" || trade.orderStatus == "3";
    if (filter === 'pending') return trade.orderStatus == "1" || trade.orderStatus == "4";
    // if (filter === 'cancelled') return trade.orderStatus == "4";
    return true;
  }).filter(trade => {
    if (!searchQuery) return true;
    
    // Check if searchQuery is from NetPositions navigation (exact match)
    if (location.state?.filterByScript) {
      return trade.stockName?.toLowerCase() === searchQuery.toLowerCase() ||
             trade.stockId?.toLowerCase() === searchQuery.toLowerCase();
    }
    
    // Regular search (partial match for manual typing)
    return trade.stockName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
           trade.stockId?.toLowerCase().includes(searchQuery.toLowerCase());
  });

  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return '';
    const date = new Date(dateTimeString);
    return date.toLocaleString().slice(0, 20).replace('T', ' ');
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const year = date.getFullYear();
    const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
    return `${day}${month}${year}`;
  };

  const getOrderTypeText = (trade) => {
    const orderType = trade.orderType || '1';
    const buy_sell = trade.buy_sell || '1';
    
    switch(orderType){
      case "1":
        return buy_sell === '1' ? 'Market Buy' : 'Market Sell';
      case "2":
        return buy_sell === '1' ? 'Limit Buy' : 'Limit Sell';
      case "3":
        return 'Stop Loss';
      default:
        return 'Market';
    }
  };

  const getTradeTypeColor = (trade) => {
    const buy_sell = trade.buy_sell || '1';
    return buy_sell === '1' ? '#1976d2' : '#d32f2f'; // Blue for Buy, Red for Sell
  };

  const getTradeTypeText = (trade) => {
    const buy_sell = trade.buy_sell || '1';
    return buy_sell === '1' ? 'BUY' : 'SELL';
  };

  const cancelOrder = async (trade) => {
    const confirmBox = window.confirm('Are you sure you want to cancel this pending order?');

    if (!confirmBox) {
      return;
    }

    try {
      const response = await fetch(`${config.API_BASE_URL}cancelPendingOrder`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          cancelledBy: userId,
          clientId: userId,
          stockId: trade.stockId,
          orderId: trade.orderId,
        }),
      });

      const data = await response.json();

      if (data.success) {
        // console.log(data);
        // window.location.reload();
        alert(data.message);
        refreshTradesAndPortfolio('both');
      } else {
        // Handle the case where the cancelation failed
        console.error('Cancelation failed', data.message);
      }
    } catch (error) {
      // Handle any errors that occurred during the request
      console.error('An error occurred:', error);
    }
  };

  return (
    <div className={`trades-page-trades ${isDarkMode ? 'dark-theme' : 'light-theme'}`} data-theme={isDarkMode ? 'dark' : 'light'}>
      {/* Search Bar */}
      <div className="search-container-trades">
        <Search style={{ height: '20px', color: 'var(--text-muted)' }} />
        <input
          type="text"
          id="search-trades-input"
          name="search-trades"
          placeholder="Search Script"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input-trades"
        />
        {/* <button className="search-button-trades">Search</button> */}
      </div>

      {/* Filter Tabs */}
      <div className="order-type-tabs-trades">
        <button 
          className={`order-tab-trades ${filter === 'executed' ? 'active' : ''}`}
          onClick={() => setFilter('executed')}
        >
          Executed
        </button>
        <button 
          className={`order-tab-trades ${filter === 'pending' ? 'active' : ''}`}
          onClick={() => setFilter('pending')}
        >
          Limit
        </button>
      </div>

      <button className="refresh-button" onClick={handleRefresh}><CachedIcon /></button>

      {/* Trades List */}
      <div className="trades-list-trades">
        {filteredTrades.length > 0 ? (
          filteredTrades.map(trade => (
            <div key={trade.orderId} className="trade-item-trades">
              {/* First Row - Script Name & Timestamp */}
              <div className="trade-header-trades">
                <div className="script-info-trades">
                  <div className="script-name-trades">{trade.stockName}</div>
                  <div className="script-expiry-trades">{trade.autoCutDate ? `${formatDate(trade.autoCutDate)}` : ''}</div>
                </div>
                <div className="timestamp-trades">
                  {formatDateTime(trade.orderDateTime)}
                </div>
              </div>

              {/* Second Row - Trade Type & Quantity/Price */}
              <div className="trade-details-trades">
                <div className="trade-type-info-trades">
                  {trade.orderStatus==4 && <span className="order-status-trades">Cancelled</span>}
                  <span 
                    className="trade-type-trades" 
                    style={{ color: getTradeTypeColor(trade) }}
                  >
                    {getTradeTypeText(trade)}
                  </span>
                  <span className="order-type-trades">{getOrderTypeText(trade)}</span>
                </div>
                <div className="quantity-price-trades">
                  <span className="lot-info-trades">({trade.orderLotQuantity || '1.00'})</span>
                  <span className="quantity-trades">{trade.orderQuantity}</span>
                  <span className="at-symbol-trades">@</span>
                  <span className="price-trades">{Number(trade.orderPrice || 0).toFixed(2)}</span>
                  {trade.orderStatus==1 && <Close onClick={() => cancelOrder(trade)} style={{marginTop:'0px', marginLeft:'5px', color: isDarkMode ? 'red' : 'red'}} />}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="trades-empty-state">
            <div className="trades-empty-state-icon">
              <div className="trades-icon-container">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <div className="trades-empty-state-content">
              <h3 className="trades-empty-state-title">No Trades Found</h3>
              <p className="trades-empty-state-description">
                No trades match your current filter criteria.
                Try adjusting your search or filter settings to find your trades.
              </p>
              <div className="trades-empty-state-actions">
                <button className="trades-primary-action-btn" onClick={() => navigate('/')}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Start Trading
                </button>
                <button className="trades-secondary-action-btn" onClick={handleRefresh}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 12A9 9 0 0 1 12 3A9 9 0 0 1 21 12A9 9 0 0 1 12 21A9 9 0 0 1 3 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 3V12L16.5 16.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Refresh Trades
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Trades;

